'use client';

import { ApolloProvider } from '@apollo/client/react';
import { ReactNode } from 'react';
import { apolloClient } from '@/lib/graphql/client';

interface GraphQLProviderProps {
  children: ReactNode;
}

/**
 * GraphQL Provider Component
 * Wraps the application with Apollo Client provider
 */
export function GraphQLProvider({ children }: GraphQLProviderProps) {
  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
}

